'use client';

import { RHFSelect } from '@/components/select/RHFSelect';
import { MuiTextField } from '@/components/textfield/MuiTextField';
import { Box, MenuItem, Typography } from '@mui/material';
import { useLogic } from './logic';
import { MuiButton } from '@/components/button/MuiButton';

export function RequestPasswordResetForm() {
  const { control, fieldName, label, onClickCancel, onClickSubmit } =
    useLogic();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 5,
        width: '400px',
        maxWidth: '90%',
        my: 6,
        mx: 'auto',
      }}
    >
      <Typography variant="JP/Heading/m/Bold/Tight" component="h1">
        iBowログインパスワードを忘れた方
      </Typography>
      <Typography variant="JP/Body/m/Regular/Normal">
        パスワードをリセットするアカウントのiBowID、メールアドレスまたは電話番号を入力してください。
      </Typography>
      <Box
        component="form"
        onSubmit={onClickSubmit}
        sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}
      >
        <RHFSelect
          name={control.register('field').name}
          control={control}
          variant="outlined"
          fullWidth
        >
          <MenuItem value="ibowid">iBowID</MenuItem>
          <MenuItem value="mail">メールアドレス</MenuItem>
          <MenuItem value="phone">電話番号</MenuItem>
        </RHFSelect>
        <MuiTextField
          key={fieldName}
          name={fieldName}
          control={control}
          label={label}
          required
          fullWidth
        />
        <MuiButton type="submit">送信</MuiButton>
        <MuiButton type="button" variant="outlined" onClick={onClickCancel}>
          キャンセル
        </MuiButton>
      </Box>
    </Box>
  );
}
